import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ContactuspageComponent } from './pages/contactuspage/contactuspage.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { Homepage2Component } from './pages/homepage2/homepage2.component';
import { FormsModule } from '@angular/forms';
import { DownloadpageComponent } from './pages/downloadpage/downloadpage.component';
import { SubmitSuccessfullComponent } from './pages/submit-successfull/submit-successfull.component';
import { TextMaskModule } from 'angular2-text-mask';
import { CreditratingpageComponent } from './pages/creditratingpage/creditratingpage.component';
import { ResearchDashboardPageComponent } from './pages/research-dashboard-page/research-dashboard-page.component';
import { OnlineclientportalpageComponent } from './pages/onlineclientportalpage/onlineclientportalpage.component';
import { SearchComponent } from './search/search.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home2',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomepageComponent
  },
  {
    path: 'home2',
    component: Homepage2Component
  },
  // {
  //   path: 'boardofdirectors',
  //   component: BoardofdirectorpageComponent
  // },
  // {
  //   path: 'sponsor',
  //   component: SponsorpageComponent
  // },
  // {
  //   path: 'auditcommittee',
  //   component: AuditcommitteepageComponent
  // },
  // {
  //   path: 'accountopening',
  //   component: AccountopeningpageComponent
  // },
  {
    path: 'contact',
    component: ContactuspageComponent
  },
  // {
  //   path: 'financialstatement',
  //   component: FinancialstatementspageComponent
  // },
  // {
  //   path: 'accountform',
  //   component: AccountopeningformComponent
  // },
  {
    path: 'SubmitSuccessfull',
    component: SubmitSuccessfullComponent
  },
  {
    path: 'online client portal',
    component: OnlineclientportalpageComponent
  }
];
@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    ContactuspageComponent,
    Homepage2Component,
    DownloadpageComponent,
    SubmitSuccessfullComponent,
    CreditratingpageComponent,
    ResearchDashboardPageComponent,
    OnlineclientportalpageComponent,
    SearchComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TextMaskModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ],
  exports: [
    AppRoutingModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
